// Core
import React, { useMemo } from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Components
import {
  LineChart,
  LineChartType,
  Series,
} from '../../../../../../layout/elements/LineChart';

// View
import { MotorCurrentProps } from './MotorCurrent.types';
import { ChartMode } from '../Trendings.types';

function MotorCurrent({
  className,
  chartMode,
  testId,
  trendingMotorCurrentData,
  vsiUnitData,
}: MotorCurrentProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  const chartId: string = `motor-current-${chartMode}`;

  const series: Series[] = useMemo((): Series[] => {
    const base: Series[] = [
      {
        name: t('common.cloudConnection'),
        field: 'edgeStatus',
        type: LineChartType.fill,
        date: 'timestamp',
        opposite: true,
      },
      {
        name: t('view.crusher.vsi.motorStatus.motor1Amps'),
        field: 'crusherMotor1Amps',
        type: LineChartType.line,
        date: 'timestamp',
        color: 'orange',
        unit: 'A',
        bullet: true,
        decimals: 2,
        minScale: 0,
        maxScale: 750,
      },
    ];
    if (vsiUnitData?.crusherMotorQty === true) {
      base.push({
        name: t('view.crusher.vsi.motorStatus.motor2Amps'),
        field: 'crusherMotor2Amps',
        type: LineChartType.line,
        date: 'timestamp',
        color: 'purple',
        unit: 'A',
        bullet: true,
        decimals: 2,
        minScale: 0,
        maxScale: 750,
      });
    }
    base.push({
      name: t('view.crusher.vsi.motorStatus.shaftRpm'),
      field: 'crusherMotorRPM',
      type: LineChartType.line,
      date: 'timestamp',
      color: 'blue',
      unit: 'RPM',
      opposite: true,
      bullet: true,
      decimals: 0,
      minScale: 0,
      maxScale: 4000,
    });
    return base;
  }, [vsiUnitData?.crusherMotorQty, t]);

  return (
    <LineChart
      activeBullet={chartMode === ChartMode.live || chartMode === ChartMode.liveAggregate}
      className={className}
      data={trendingMotorCurrentData}
      id={chartId}
      series={series}
      testId={testId}
    />
  );
}

export { MotorCurrent };
